import { RestoreCartItem } from '../api/types';

interface RestoreCartProps {
  items: RestoreCartItem[];
  onRemove: (recordId: string) => void;
}

export function RestoreCart({ items, onRemove }: RestoreCartProps) {
  if (items.length === 0) {
    return (
      <div className="card" style={{ textAlign: 'center', color: 'var(--color-text-muted)' }}>
        <p>No records added to restore cart yet.</p>
        <p style={{ fontSize: '0.8rem' }}>Search for records and add them to the cart.</p>
      </div>
    );
  }

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginBottom: '0.75rem',
        }}
      >
        <h3 style={{ margin: 0 }}>
          Restore Cart ({items.length} record{items.length !== 1 ? 's' : ''})
        </h3>
      </div>
      <table aria-label="Records selected for restore">
        <thead>
          <tr>
            <th scope="col">Object Type</th>
            <th scope="col">Record ID</th>
            <th scope="col">Name</th>
            <th scope="col">Version</th>
            <th scope="col">Actions</th>
          </tr>
        </thead>
        <tbody>
          {items.map((item) => (
            <tr key={item.recordId}>
              <td>
                <span className="badge badge-info">{item.objectType}</span>
              </td>
              <td>
                <code style={{ fontSize: '0.8rem' }}>{item.recordId}</code>
              </td>
              <td>{item.name}</td>
              <td>
                {item.versionId ? (
                  <code style={{ fontSize: '0.75rem' }}>{item.versionId.slice(0, 8)}</code>
                ) : (
                  <span style={{ color: 'var(--color-text-muted)' }}>Latest</span>
                )}
              </td>
              <td>
                <button
                  className="danger"
                  onClick={() => onRemove(item.recordId)}
                  aria-label={`Remove ${item.name} from cart`}
                  style={{ padding: '0.25rem 0.5rem', fontSize: '0.75rem' }}
                >
                  Remove
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
